export const Colors = {
  primaryBg: "#222222",
  floatBg: "#333333",
  primaryText: "#eeeeee",
  secondaryText: "#EEEEEE",
  border: "#444444",
  chillBlue: "#0096CA",
};
